import React from 'react';
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import { useTranslation } from 'next-i18next';

import NavigatorLink from 'views/common/components/Logical/NavigatorLink';

const PREFIX = 'GetStartedBtn';

const classes = {
  getStarted: `${PREFIX}-getStarted`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.getStarted}`]: {
    padding: theme.spacing(0.75, 5),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(1.5, 6.75),
    },
  },
}));

const GetStartedBtn = ({ styleClass }) => {
  const { t } = useTranslation('fe_er_rent_my_motorcycle');

  return (
    <Root>
      <Button
        variant="contained"
        component={NavigatorLink}
        color="primary"
        href="https://www.eagleshare.com/user/vehicles"
        disableElevation
        classes={{ root: styleClass || classes.getStarted }}>
        {t('fe_er_rent_my_motorcycle:get_started')}
      </Button>
    </Root>
  );
};

export default GetStartedBtn;
